import _mixpanel from 'mixpanel-browser';

const handler = {
  get: function (target: typeof _mixpanel, prop: string) {
    if (import.meta.env.VITE_MIXPANEL_TOKEN) {
      const value = Reflect.get(target, prop);
      if (typeof value === 'function') {
        return function (this: typeof _mixpanel, ...args: any[]) {
          try {
            return value.apply(this, args);
          } catch {
            return undefined;
          }
        };
      }
      return value;
    } else {
      const value = Reflect.get(target, prop);
      if (typeof value === 'function') {
        return function () {
          return undefined;
        };
      }
      return undefined;
    }
  },
};

const mixpanel = new Proxy(_mixpanel, handler) as typeof _mixpanel;

export default mixpanel;
